import React, {Component} from 'react';
import {Input, AutoComplete, Icon} from 'antd';
import {locdau} from '../utils'
const Option = AutoComplete.Option;

class FilterStationAutoComplete extends Component {
  constructor(props) {
    super(props);
    const {stations} = this.props
    this.state = {
      stations: stations,
      searchValue: ''
    };
  }

  handleChange = (value, label) => {
    if (value === "") {
      this.props.onSelect(value)
    }
  }

  handleSelect = (value, option) => {
    this.props.onSelect(option.key)
  }

  handleSearch = (value) => {
    const {stations} = this.props
    const searchValue = value
    if (searchValue !== "") {
      const filterStations = stations.filter((item) => {
        const kodauName = locdau(item.Name).toLowerCase()
        const kodauSearch = locdau(searchValue).toLowerCase()
        const indexName = kodauName.indexOf(kodauSearch);
        const lowerHardwareID = item.HardwareIDHex.toLowerCase()
        const indexHardwareID = lowerHardwareID.indexOf(kodauSearch);
        return (indexName > -1 || indexHardwareID > -1)
      }).map((item) => {
        const kodauName = locdau(item.Name).toLowerCase()
        const kodauSearch = locdau(searchValue).toLowerCase()
        const indexName = kodauName.indexOf(kodauSearch);
        const beforeStrName = item.Name.substr(0, indexName);
        const matchStrName = item.Name.substr(indexName, searchValue.length);
        const afterStrName = item.Name.substr(indexName + searchValue.length);
        const titleName = indexName > -1
          ? <span>
              {beforeStrName}
              <span className="highlight">{matchStrName}</span>
              {afterStrName}</span>
          : item.Name

        const lowerHardwareID = item.HardwareIDHex.toLowerCase()
        const indexHardwareID = lowerHardwareID.indexOf(kodauSearch);
        const beforeStrHardwareID = item.HardwareIDHex.substr(0, indexHardwareID);
        const matchStrHardwareID = item.HardwareIDHex.substr(indexHardwareID, searchValue.length);
        const afterStrHardwareID = item.HardwareIDHex.substr(indexHardwareID + searchValue.length);

        const tilteHardwareID = indexHardwareID > -1
          ? <span>{beforeStrHardwareID}
              <span className="highlight">{matchStrHardwareID}</span>
              {afterStrHardwareID}</span>
          : item.HardwareIDHex

        const title = (<span>
          {titleName}
          <span className="certain-search-item-right">{tilteHardwareID}</span>
        </span>)
        return {
          ...item,
          Title: title
        };
      })
      this.setState({searchValue: value, stations: filterStations})
    } else {
      this.setState({searchValue: "", stations: stations})
    }
  }

  render() {
    const {stations} = this.state
    const options = stations.map((item) => {
      const title = item.Title
        ? item.Title
        : <span>{item.Name}
          <span className="certain-search-item-right">{item.HardwareIDHex}</span>
        </span>
      return (<Option key={item.ID} value={item.Name}>{title}
      </Option>)
    })
    return (<div className="certain-category-search-wrapper" style={{
        width: '100%',
        display: 'inline-block'
      }}>
      <AutoComplete className="certain-category-search" dropdownClassName="certain-category-search-dropdown" dropdownMatchSelectWidth={false} size="large" style={{
          width: '100%'
        }} dataSource={options} placeholder="Tìm theo tên" optionLabelProp="value" onChange={this.handleChange} onSelect={this.handleSelect} onSearch={this.handleSearch}>
        <Input suffix={<Icon type = "search" className = "certain-category-icon" />} style={{
            width: '100%'
          }}/>
      </AutoComplete>
    </div>)
  }
}

export default FilterStationAutoComplete



// WEBPACK FOOTER //
// ./src/components/FilterStationAutoComplete.js